import React from 'react';

import {
  useTaskStatusColor,
  TaskStatusColorHookProps
} from '../secure-portal/tasks/Task.hooks';
import { StyledStatusLabel } from './StatusLabel';

export interface TaskStatusLabelProps extends TaskStatusColorHookProps {
  size?: 'normal' | 'small';
  className?: string;
}

const TaskStatusLabel: React.FC<TaskStatusLabelProps> = (
  props: TaskStatusLabelProps
) => {
  const { task, status, size = 'normal', className = '', getLabel } = props;
  const { color, label: labelValue } = useTaskStatusColor({
    task,
    status,
    getLabel
  });
  const classes = ['status-label'];
  if (className) classes.push(className);
  if (size !== 'normal') classes.push(size);
  return (
    <StyledStatusLabel
      style={color}
      title={labelValue}
      className={classes.join(' ')}
    >
      {labelValue}
    </StyledStatusLabel>
  );
};

export default TaskStatusLabel;
